/**
 * @module ReasoningLoadingState
 * @purpose Loading state component for the reasoning panel — spinner + descriptive text.
 * @depends react-i18next
 * @dependedOnBy CanvasReasoningPanel
 *
 * @rules
 * - Performance: pure display — no data fetching
 * - State: none
 * - Errors: n/a
 */

import { useTranslation } from 'react-i18next'

/**
 * Renders the reasoning panel loading state with status text.
 *
 * @behaviour Uses role="status" aria-busy="true" for screen readers.
 *            Text sourced from analysis.reasoning.loading.* namespace.
 * @errors n/a — purely presentational
 */
export function ReasoningLoadingState(): React.ReactElement {
  const { t } = useTranslation('analysis')
  return (
    <div role="status" aria-busy="true" className="flex flex-col items-center gap-2 px-4 py-8">
      <p className="text-sm" style={{ color: 'var(--text)' }}>
        {t('reasoning.loading.title')}
      </p>
      <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
        {t('reasoning.loading.subtitle')}
      </p>
    </div>
  )
}
